import { AuthProvider, useAuth } from './app/AuthContext';
import { QueryProvider } from './app/QueryProvider';
import { ToastProvider } from './app/ToastProvider';
import { Spinner } from './components/Spinner';
import { LoginScreen } from './features/auth/LoginScreen';
import { Dashboard } from './pages/Dashboard';

function Shell() {
  const { state } = useAuth();
  if (state.status === 'loading') {
    return (
      <main className="min-h-screen flex items-center justify-center">
        <Spinner size={24} />
      </main>
    );
  }
  if (state.status === 'anonymous') return <LoginScreen />;
  return <Dashboard />;
}

export default function App() {
  return (
    <QueryProvider>
      <ToastProvider>
        <AuthProvider>
          <Shell />
        </AuthProvider>
      </ToastProvider>
    </QueryProvider>
  );
}
